import ImageGallery from "./../components/ImageGallery";
import React, { useState, useEffect } from "react";
import api from "../api";
import { type } from "@testing-library/user-event/dist/type";
import { Button, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";

import {
  faCamera,
  faUpload,
  faSearch,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";

const ImageManager = ({ event, admin = false }) => {
  const [images, setImages] = useState([]);
  const [statsProcessing, SetStatsProcessing] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();

  const fetchImages = async () => {
    setIsUploading(true);
    try {
      const response = await api.get(`/images?eid=${event.event_id}`);

      if (typeof response.data !== "object") {
        console.log("Error fetching images:", response.data);
        return;
      }

      setImages(response.data);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const fetchStatsProcessing = async () => {
    const poll = async () => {
      try {
        const response = await api.get(
          `/processed_images_stats?eid=${event.event_id}`
        );

        if (typeof response.data !== "object") {
          console.log("Error fetching image stats:", response.data);
          return;
        }

        SetStatsProcessing(response.data);

        if (response.data.is_processing) {
          setTimeout(poll, 2000); // Retry after 2 seconds
        }
      } catch (error) {
        console.error("Error fetching image stats:", error);
      }
    };

    poll();
  };

  const handleRedirect = (path, set_id_name = true) => {
    // prevent default action
    if (path && set_id_name) {
      return () => navigate(`/${path}/${event.id_name}/`);
    } else if (path && !set_id_name) {
      return () => navigate(`/${path}`);
    } else {
      return () => navigate(`/${event.id_name}`);
    }
  };

  // retrieve all the images uploaded for the event on load
  useEffect(() => {
    fetchImages();
    fetchStatsProcessing();
  }, [event.event_id]);

  return (
    /* Show the event name */
    event && (
      <>
        <div className="container rounded p-2 m-1">
          {/* spinner when is uploading */}
          {isUploading && (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                {/* <span className="visually-hidden">Loading...</span> */}
              </div>
            </div>
          )}

          {/* show gallery is images found, else show now images found */}
          {images.length > 0 ? (
            /* Image Gallery component */
            <>
              {/* Upload more*/}
              <div className="container m-1 d-flex justify-content-center align-items-center">
                <div className="mb-3">
                  {/* redirection to /magic finder */}
                  {!admin && (
                    <Button
                      className="m-1 shadow btn-sm"
                      variant="secondary"
                      onClick={handleRedirect("event")}
                    >
                      <FontAwesomeIcon
                        icon={faSearch}
                        size="1x"
                        className="me-1"
                      />
                      Magic finder
                    </Button>
                  )}
                </div>
              </div>
              <Col>
                <Col className="m-2 text-center">
                  <small>Available: {images.length} </small>

                  {admin && (
                    <>
                      <small className="text-secondary m-2">
                        Processed: {statsProcessing.nb_processed_images}
                      </small>

                      {statsProcessing.is_processing && (
                        <>
                          <small className="text-secondary m-2">
                            {statsProcessing.processed_images_percent}%
                          </small>
                          <FontAwesomeIcon icon={faCog} spin size="1x" />
                        </>
                      )}
                    </>
                  )}
                </Col>
              </Col>

              <ImageGallery
                event_id={event.event_id}
                images={images}
                show_delete={admin}
                setImages={setImages}
              />
            </>
          ) : (
            !isUploading && (
              <div className="mt-5 d-flex justify-content-center align-items-center">
                <Button
                  className="p-3 rounded shadow"
                  variant="outline-success"
                  onClick={handleRedirect("admin/upload")}
                >
                  <div className="mb-1">Upload your images to get started</div>
                  <FontAwesomeIcon icon={faUpload} size="1x" bounce />
                </Button>
              </div>
            )
          )}
        </div>
      </>
    )
  );
};
export default ImageManager;
